import React from "react";
import { createSvgIconComponent } from "../";

export const IconClubCatchMail = createSvgIconComponent({
  viewBox: "0 0 68 46",
  fill: "none",
  children: (
    <>
      <g clipPath="url(#icon-cc-mail-clip)">
        <path
          d="M65.056 46H9.593c-1.624 0-2.945-1.245-2.945-2.763V39.76h1.974v3.477c0 .44.44.79.971.79h55.478c.531 0 .971-.35.971-.79V8.016c0-.44-.44-.79-.971-.79h-4.69V5.254h4.69c1.624 0 2.944 1.245 2.944 2.763v35.221C68 44.755 66.68 46 65.055 46z"
          fill="currentColor"
        />
        <path
          d="M8.622 39.76H6.648V8.017c0-1.518 1.321-2.763 2.945-2.763h50.788v1.974H9.593c-.531 0-.971.349-.971.789v31.745z"
          fill="currentColor"
        />
        <path
          d="M2.945 40.747C1.32 40.747 0 39.502 0 37.984V2.763C0 1.245 1.32 0 2.945 0h55.477c1.624 0 2.945 1.245 2.945 2.763 0 .547-.44.987-.987.987a.985.985 0 01-.986-.987c0-.44-.425-.79-.956-.79H2.944c-.547 0-.972.35-.972.79v35.221c0 .44.44.79.972.79.546 0 .986.44.986.986a.995.995 0 01-.986.987z"
          fill="currentColor"
        />
        <path
          d="M29.137 24a.783.783 0 01-.451-.14L11.41 12.676c-.412-.251-.532-.81-.28-1.244a.822.822 0 011.183-.293L29.59 22.322a.923.923 0 01.28 1.245.838.838 0 01-.732.433zM45.86 24a.839.839 0 01-.731-.433c-.253-.434-.12-.993.279-1.245l17.286-11.187a.834.834 0 011.183.294c.24.42.12.993-.279 1.245L46.312 23.86a.784.784 0 01-.452.14z"
          fill="currentColor"
        />
        <path
          d="M41.732 19.33l-.845-2.464a1.246 1.246 0 00-1.853-.674l-5.356 3.255a1.453 1.453 0 00-.606.749l-2.983 8.269c-.262.724.074 1.512.75 1.757l7.392 2.687c.676.246 1.436-.142 1.697-.867l2.983-8.269a1.46 1.46 0 00.013-.965l-1.192-3.477zm-.088 6.448l-2.391 1.104a.423.423 0 00-.24.313l-.448 2.603a.422.422 0 01-.727.215l-1.785-1.941a.423.423 0 00-.37-.132l-2.606.376a.424.424 0 01-.428-.627l1.288-2.305a.425.425 0 00.01-.394l-1.16-2.371a.423.423 0 01.461-.602l2.58.517a.421.421 0 00.378-.112l1.888-1.841a.422.422 0 01.713.254l.308 2.624c.016.139.099.26.222.326l2.328 1.233a.425.425 0 01-.021.76zm-1.396-8.67a.494.494 0 10-.987-.002.494.494 0 00.987.002z"
          fill="#F0D511"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="icon-cc-mail-clip">
          <path fill="#fff" d="M0 0h68v46H0z" />
        </clipPath>
      </defs>
    </>
  ),
});
